'use client'

import { useRef } from "react"
import styles from "./ua.module.scss";
import Slideout from "@/components/slideout/Slideout"
import Button from "@/components/button/Button";
import Icon from "@/components/icon/Icon";
import StackedPanel from "@/components/panel/StackedPanel";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelTitle from "@/components/panel/PanelTitle";
import PanelBody from "@/components/panel/PanelBody";
import { URL_MAPPINGS } from "@/utils/Actions";
import Link from "next/link";
import { useRouter } from "next/navigation";
import LocationDropdown from "./LocationDropdown";
import { emitEvent } from "@/components/plugins/EventListener";
import SiteLogo from "./SiteLogo";
import TradeIndicator from "../trade/TradeIndicator";

export default function HeaderMenuButton(props) {
  
  const router = useRouter()
  const slide = useRef()
  const location = useRef()
  
  const toggle = () => {
    slide.current.toggle()
  }
  
  const onClick = (mi) => {
    toggle()
    if (mi.type == "profile") {
      emitEvent("show_profile_slide")
    } else if (mi.type == "favorites") {
      emitEvent("show_favorites_slide")
    } else if (mi.type == 'service') {
      emitEvent("show_schedule_service", { mobile: true })
    } else if (mi.type == "location") {
      location.current.toggle()
    } else {
      router.push(URL_MAPPINGS[mi.type])
    }
  }
  
  const renderMenu = (mi) => {
    let label = mi.label
    let icon = null
    let iconClass = null
    if (mi.type == 'favorites') {
      icon = "heart-filled"
      iconClass = "text-red"
    } else if (mi.type == 'location') {
      icon = "map-marker"
      label = label + " (" + props.site?.session?.vehicles?.location?.zip + ")"
    }
    return <div key={mi.type + "_" + mi.label} className={styles.mml}>
      <Button theme={['transparent','nopad']} label={  mi.label } onClick={ e => onClick(mi) }>
        <div className="flex-row flex-full flex-with-gap flex-align-middle">
          { icon &&
          <div className={"flex-col text-primary " + iconClass}>
            <Icon {...props} name={ icon }></Icon>
          </div>
          }
          <div className="flex-col flex-stretch text-align-left text-primary">
            { label }
          </div>
          { mi.type == 'trade' &&
          <div className="flex-col">
            <TradeIndicator {...props} theme={'badge-inline'}></TradeIndicator>
          </div>
          }
          <div className="flex-col text-primary">
            <Icon {...props} name="chevron-right"></Icon>
          </div>
        </div>
      </Button>
    </div>    
  }
  
  return <>
    <Button plain={true} className={ styles.mi + ' ' + props.className} onClick={e => toggle(e)} label={ 'Show Menu' }>
      <Icon {...props} name="menu-bar"></Icon>
    </Button>
    <Slideout ref={slide}>
      <StackedPanel>
        <PanelHeader>
          <PanelTitle>
            <Link href={'/'} className={ styles.logo } aria-label={'Home'} prefetch={false}>
              <SiteLogo image={props.site.siteSettings.logo_image} height={props.site.theme.header.headerLogoHeight} alt={'Logo'}></SiteLogo>
            </Link>
          </PanelTitle>
          <div>
            <Button theme={'icon'} onClick={e => toggle(e)} label={ 'Close' }>
              <Icon {...props} name="x"></Icon>
            </Button>
          </div>
        </PanelHeader>
        <PanelBody padded={true}>
          <div className={styles.mm}>
            { props.site.siteSettings.header.headerleft.items.map((mi,i) => (
              renderMenu(mi)
            ))}
            { props.site.siteSettings.header.headerright.items.map((mi,i) => (
              renderMenu(mi)
            ))}
            <div className={styles.mml}>
              <Button theme={['transparent','nopad']} label={ 'Profile' } onClick={ e => onClick({type:'profile'}) }>
                <div className="flex-row flex-full flex-with-gap">
                  <div className={"flex-col text-primary"}>
                    <Icon {...props} name={ 'user' }></Icon>
                  </div>
                  <div className="flex-col flex-stretch text-align-left text-primary">
                    Profile
                  </div>
                  <div className="flex-col text-primary">
                    <Icon {...props} name="chevron-right"></Icon>
                  </div>
                </div>
              </Button>
            </div>    
          </div>
        </PanelBody>
      </StackedPanel>
    </Slideout>    
    <LocationDropdown {...props} ref={location}></LocationDropdown>
  </>

  
}